<template>
	<div class="my-table contactPage">
		<!-- 面包屑组件 -->
		<div class="searchBox relative">
			<div class="current-location">
				<img class="location" src="@/assets/picture/icon/location.png">
				<span>{{$t('patfromShare.txt1')}}</span>
				<span>{{$t('patfromShare.txt2')}} / {{$t('patfromShare.txt3')}} / {{shareType==0?$t('patfromShare.txt4'):$t('patfromShare.txt5')}}</span>
			</div>
		</div>
		<!-- 面包屑 -->
		<el-card class="tableCard p30">
			<div class="contactTitle flexCenter mb50">
				<div>
					<!-- <span :class="shareType==Number(index+1)?'activeTitle':''" v-for="(item,index) in settingOption" :key="index" @click="goItemPage(item,index)">{{item.name}}</span> -->
					<span :class="shareType==1?'activeTitle':''"  @click="goItemPage(item,0)">{{ $t('patfromShare.txt4') }}</span>
					<span v-if="enableDowloadUserData" :class="shareType==2?'activeTitle':''"  @click="goItemPage(item,1)">{{ $t('patfromShare.txt5') }}</span>

				</div>
				<div class="flexEnd">
					<div class="onCancelBtn mr30" @click="onBack">{{$t('patfromShare.txt6')}}</div>
					<div v-if="shareType == 1" class="searchBtn" @click="confirmPlatformShare('fromData')">{{$t('patfromShare.txt7')}}</div>
					<div v-if="shareType == 2" class="searchBtn" @click="confirmLink('fromData')">{{link ? $t('patfromShare.txt8'):$t('patfromShare.txt9')}}</div>
				</div>
			</div>
			<!-- 平台分享 -->
			<div v-if="shareType===1">
				<div class="transferBox">
					<el-transfer filterable :filter-placeholder="$t('patfromShare.txt10')" :filter-method="filterMethod" :titles="[$t('patfromShare.txt11'), $t('patfromShare.txt11')]" v-model="checkedList" :props="transferProps" :data="dataList">
					</el-transfer>
				</div>
			</div>
			<!-- 链接分享 -->
			<div v-else>
				<div class="editForm editWidth">
					<el-form :model="fromData" ref="fromData" label-width="100px" class="demo-ruleForm">
						<template v-if="!link">
							<el-form-item :label="$t('patfromShare.txt12')">
								<span>{{$t('patfromShare.txt13')}} + {{$t('patfromShare.txt14')}}</span>
								<p class="tips">{{$t('patfromShare.txt15')}}</p>
							</el-form-item>
							<el-form-item :label="$t('patfromShare.txt16')">
								<el-select v-model="expirationTime" :placeholder="$t('patfromShare.txt17')">
									<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
								</el-select>
							</el-form-item>
						</template>
						<template v-if="link">
							<el-form-item :label="$t('patfromShare.txt18')">
								<el-input v-model="link" readonly ref="linkInput" :placeholder="$t('patfromShare.txt19')"></el-input>
							</el-form-item>
							<el-form-item :label="$t('patfromShare.txt20')">
								<el-input v-model="validCode" readonly :placeholder="$t('patfromShare.txt19')"></el-input>
								<p class="tips" style="margin-top: 15px">{{$t('patfromShare.txt21')}}</p>
							</el-form-item>
						</template>
					</el-form>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
	import qs from 'qs';
	export default {
		data() {
			return {
				shareType: 1,
				settingOption: [
				{
					name: this.$t('patfromShare.txt4')
				},
				{
					name: this.$t('patfromShare.txt5')
				},
				],
				checkedList: [],
				transferProps: {
					key: 'id',
					label: 'userName'
				},
				link: '',
            validCode: '',
            expirationTime: '',
				dataList: [],
				patahs:[],
				fromData:{},//分享参数
				shareList:[],
				options:[
                { label: this.$t('patfromShare.txt22'), value: 7 },
                { label: this.$t('patfromShare.txt23'), value: 15 },
                { label: this.$t('patfromShare.txt24'), value: 30 },
                { label: this.$t('patfromShare.txt25'), value: 360 * 10 },
            ],//有效期
            loading: false,
			enableDowloadUserData: true,
			};
		},
		created() {
			let list = JSON.parse(this.$route.query.row);
			console.log(list,'list');
			this.shareList = list;

            this.enableDowloadUserData = window.sessionStorage.getItem("enableDowloadUserData")=='true';
            console.log(this.enableDowloadUserData,'this.enableDowloadUserData');

			this.loadData();
		},
		methods: {
			// 返回上一页
			onBack() {
				this.$router.go(-1);
			},
			async loadData(){
				const { data: res } = await this.$http.post("/user/info/list/shareUsers");
				if(!res.success){
					return this.$message.error(res.message);
				}
				this.dataList = res.result;
			},
			goItemPage(item,index){
				this.shareType = Number(index+1);
			},
			filterMethod(query, item) {
				return item.userName.indexOf(query) > -1;
			},
			// 平台分享
			async confirmPlatformShare() {
				if(!this.checkedList.length) {
					return this.$message.warning(this.$t('patfromShare.txt26'))
				}
				const users = this.checkedList.map(item => {
					return {
						id: item
					}
				})
				const data = {
					patahs:this.shareList,
					shareType: this.shareType,
					users,
					verification: '',
				}
				const { data: res } = await this.$http.post("/share/add", data);
				if(res.success){
					this.$message({
						message: res.message,
						type: 'success'
					});
					this.$router.go(-1);
				}else{
					return this.$message.error(res.message);
				}
			},
			// 链接分享
			async confirmLink() {
            if(this.link) {
                var Url2=this.$refs.linkInput
                Url2.select(); // 选择对象
                document.execCommand("copy"); // 执行浏览器复制命令
                return this.$message.success(this.$t('patfromShare.txt27'))
            } 
            if(this.expirationTime === '') {
                return this.$message.warning(this.$t('patfromShare.txt28'))
            }
            const time = this.expirationTime * 24 * 60 * 60 * 1000 + Date.now();
            const data = {
                expirationTime: time, // 过期时间
                patahs:this.shareList,
                // patahs: this.patahs.map(item => item.path), 
                shareType: this.shareType,
                users: [],
            }
            if(this.loading) return 
            this.loading = true
            const { data: res } = await this.$http.post("/share/add", data);
            this.loading = false;
            if(!res.success){
                return this.$message.error(res.message);
            }
            this.link = location.origin + `/receiveShare?id=${res.result.id}&verification=${res.result.verification}`;
            this.validCode = res.result.verification
            this.$message.success(this.$t('patfromShare.txt29'));
        },
		},
	};
</script>

<style lang="less" scoped>
	.contactPage {
		/deep/ .checkbox, .form-control, /deep/ .radio, /deep/ input[type=file], /deep/ output{
			display: none !important;
		}
		/deep/ .el-input{
			width: 89%;
		}
		.contactTitle{
			font-size: 30px;
			font-weight: 500;
			color: #AEB0B9;
			margin-bottom: 40px;
		}
		.contactTitle span{
			margin-right: 30px;
			cursor: pointer;
		}
		.activeTitle{
			font-size: 30px;
			font-weight: 500;
			color: #222222;
		}
		.blueTxt{
			color: #1B3B7C;
		}
		.back {
			display: inline-block;
			margin-right: 2.6rem;

			img {
				width: 1.8rem;
				height: 1.8rem;
				margin-right: 0.7rem;
			}

			span {
				font-size: 1.6rem;
				font-weight: 400;
				color: #333333;
			}
		}
		.tips{
			color: #1B7C3A;
			font-size: 14px;
		}
		.transferBox{
			.elTransferTitle{
				padding:3.1rem 0 2.1rem 0;
				font-size: 14px;
				font-weight: 500;
				color: #222222;
			}
			/deep/ .el-transfer{
				display: flex;
				justify-content: center;
				.el-transfer-panel{
					background: #F4F4F4;
					border-radius: 18px;
					overflow: hidden;
					border: none;
				}
				.el-transfer-panel__header{
					background: #DFE2E8;
					.el-checkbox__label{
						font-weight: 500;
						color: #1B3B7C;
						font-size: 14px;
					}
				}
				.el-transfer__buttons{
					display: flex;
					justify-content: center;
					align-content: center;
					padding: 0 !important;
					.el-transfer__button{
						padding: 0 !important;
						width: auto;
						height: auto;
						background: #fff;
						border: none;
						margin: 0;
					}
					.el-button+.el-button{
						margin: 0;
					}
				}
			}
		}

	}
	.handleBtn{
		padding: 0;
	}
</style>
